import React, { FunctionComponent } from 'react'
import { useItemsIds, useItemsCount } from '../../../../state'
import { Item } from './Item'
import styles from './styles.module.css'

export const DetailedItemList: FunctionComponent = () => {
  const ids = useItemsIds()
  const count = useItemsCount()

  if (count === 0) {
    return null
  }

  return (
    <ul className={styles.list}>
      {ids.map((id, index) => (
        <Item key={id} id={id} index={index} />
      ))}
    </ul>
  )
}
